import { Squash as HH } from 'hamburger-react'
import { cn } from '@/lib/utils'

interface HamurgerProps {
    mainMenuOpen: boolean,
    toggleMainMenu: () => void,
}

const Hamburger = ({ toggleMainMenu, mainMenuOpen }: HamurgerProps) => {
    return (
        <div className={cn('hamburger relative -mr-3 ml-auto cursor-pointer lg:hidden')} onClick={toggleMainMenu}>
            <HH toggled={mainMenuOpen} size={24} label='Show menu' />
        </div>
    )
}

export { Hamburger }
